import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IsfV1Model } from '@data-layer/models/isf-v1';
import { enumPaymentState } from '@data-layer/enums/payments';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';

@Component({
  selector: 'status-warning',
  templateUrl: './status-warning.component.html',
  styleUrls: ['./status-warning.component.scss'],
})
export class StatusWarningComponent implements OnInit {
  @Input() public currIsf: IsfV1Model;
  @Input() public currES: EntrySummaryModel;
  @Output() public goToEdit: EventEmitter<any> = new EventEmitter<any>();

  public headerText: string = 'LABELS.SOMETHING_DONT_WORK_TITLE';
  public text: string = 'INFO.RESULT.C4_TEXT';

  private isIsf: boolean = true;
  private isES: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this.isIsf = !!(this.currIsf && this.currIsf.id);
    this.isES = !!(this.currES && this.currES.id);

    this.setHeaders();
  }

  public get referenceNumber(): string {
    return this.isIsf ? this.currIsf.referenceNumber : this.isES ? this.currES.referenceNumber : '';
  }

  public goToSummary() {
    this.goToEdit.emit();
  }

  private setHeaders() {
    if (this.isIsf) {
      if (this.currIsf.paymentState === enumPaymentState.PENDING) {
        this.headerText = 'INFO.RESULT.C18_HEADER';
        this.text = 'INFO.RESULT.C18_TEXT';
      } else {
        this.headerText = 'LABELS.SOMETHING_DONT_WORK_TITLE';
        this.text = 'INFO.RESULT.C4_TEXT';
      }
    }
  }
}
